import React from "react";
import { MessagesProvider } from "./MessagesContext";
import MessageFilter from "./MessageFilter";
import MessagesList from "./MessagesList";
import MessageForm from "./MessageForm";
import MessageLog from "./MessageLog";

const MessagesPage = () => {
  return (
    <MessagesProvider>
      <MessageFilter />
      <MessagesList />
      <MessageForm />
      <MessageLog />
    </MessagesProvider>
  );
};

export default MessagesPage;
